import { useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../AuthContext';
import { getAttribution } from '../utils/attribution';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:3001') + '/api';

// Tags the Microsoft Clarity session with who the logged-in user is, so
// recordings can be FILTERED in the dashboard (tier / source / campaign /
// email) instead of scrolling every session blind. This is what lets us tell
// a paying dealer from a free prospect at a glance.
//
// No-ops safely when Clarity isn't present (ad-blocked, or the user declined
// cookies, CookieConsent calls clarity('stop'), after which these are ignored).
export default function ClarityTagger() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    let cancelled = false;

    const tag = (tier) => {
      const c = window.clarity;
      if (typeof c !== 'function') return;
      try {
        const attr = getAttribution();
        if (user.email) {
          c('identify', user.email);     // friendly per-user id (Clarity hashes it)
          c('set', 'email', user.email); // also a filterable tag
        }
        c('set', 'tier', tier || 'unknown');
        c('set', 'source', attr.signupSource || 'direct');
        if (attr.signupCampaign) c('set', 'campaign', attr.signupCampaign);
      } catch { /* clarity not ready / consent declined, ignore */ }
    };

    // Tier is the highest-value tag (paying vs free), so fetch the subscription.
    // Still tag email/source even if that call fails.
    axios.get(`${API}/stripe/subscription`)
      .then(res => { if (!cancelled) tag(res.data?.tier); })
      .catch(() => { if (!cancelled) tag(null); });

    return () => { cancelled = true; };
  }, [user]);

  return null;
}
